import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../../store/products/productReducer";
import Spinner from "../../../components/Spinner/Index";
import NotFound from "../../NotFound/Index";

const Shopping = () => {
    const dispatch = useDispatch();
    const { products, isLoading, isError, message } = useSelector((state) => state.products);

    useEffect(() => {
        dispatch(fetchProducts());
    }, [dispatch]);

    const resolveImagePath = (path) => {
        try {
            console.log(path);
            return require(`../../../${path}`);
        } catch {
            return "https://via.placeholder.com/300"; // Fallback to a placeholder if image not found
        }
    };


    if (isLoading) return <Spinner />;
    if (isError) return <NotFound />;

    const categoriesWithProducts = products.reduce((acc, product) => {
        const category = product.category_id;
        if (!acc[category._id]) {
            acc[category._id] = { ...category, products: [] };
        }
        acc[category._id].products.push(product);
        return acc;
    }, {});

    return (
        <div className="bg-white">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                {Object.values(categoriesWithProducts).map((category) => (
                    <div key={category._id} className="">
                        <h3 className="text-xl font-bold text-gray-900">{category.name}</h3>
                        <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8">
                            {category.products.map((product) => (
                                <div key={product._id} className="group relative">
                                    {/* Product Image */}
                                    <div className="aspect-square w-full rounded-md bg-gray-200 overflow-hidden group-hover:opacity-75 lg:aspect-auto lg:h-80">
                                        <img
                                            src={resolveImagePath(product.image_url)}
                                            alt={product.name}
                                            className="object-fill w-full h-full"
                                        />
                                    </div>
                                    {/* Product Name and Price */}
                                    <div className="mt-6 flex items-center justify-between">
                                        <div>
                                            <h3 className="text-xl text-gray-700 py-4">
                                                <Link to={`${product.slug}`}>
                                                    <span aria-hidden="true" className="absolute inset-0" />
                                                    {product.name}
                                                </Link>
                                            </h3>
                                        </div>
                                        <p className="text-xl font-medium text-gray-900">${product.price}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Shopping;
